import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: '#3b82f6', light: '#60a5fa', dark: '#2563eb' },
        secondary: { main: '#64748b', light: '#94a3b8', dark: '#475569' },
        error: { main: '#ef4444' },
        warning: { main: '#f59e0b' },
        success: { main: '#22c55e' },
        background: { default: '#0f172a', paper: '#1e293b' },
        text: { primary: '#f8fafc', secondary: '#cbd5e1', disabled: '#94a3b8' },
        divider: '#334155',
    },
    typography: {
        fontFamily: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        h1: { fontSize: '1.5rem', fontWeight: 600 },
        h2: { fontSize: '1.25rem', fontWeight: 600 },
        h3: { fontSize: '1.125rem', fontWeight: 600 },
        body1: { fontSize: '0.875rem' },
        body2: { fontSize: '0.8125rem' },
    },
    shape: { borderRadius: 8 },
    components: {
        MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 500 } } },
        MuiTextField: { styleOverrides: { root: { '& .MuiOutlinedInput-root': { backgroundColor: '#1e293b' } } } },
        MuiSelect: { styleOverrides: { root: { backgroundColor: '#1e293b' } } },
        MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
        MuiTableCell: { styleOverrides: { root: { borderColor: '#334155' }, head: { fontWeight: 600, backgroundColor: '#0f172a' } } },
    },
});

export default theme;
